/**
 * All filters must implement this interface.
 */

/****************************************************************/
/**                   Collaboration Graph                      **/
/****************************************************************/

export const SpaceContainerType = 'confluenceSpace';
export const ProjectContainerType = 'jiraProject';

/****************************************************************/
/**                   Multi Site                               **/
/****************************************************************/

/**
 * Defines the properties to be passed to serve results from multiple tenants.
 *
 * @siteUrl {string} can be thought of as the hostUrl without a trailing '/'. Not to be confused with 'baseUrl' which has the value '/wiki' for confluence.
 */